const BASE = process.env.REACT_APP_BACKEND_URL;

export async function api(path, { method = "GET", body, form } = {}) {
  const opts = { method, credentials: "include", headers: {} };
  if (body) {
    opts.headers["Content-Type"] = "application/json";
    opts.body = JSON.stringify(body);
  }
  if (form) opts.body = form;
  const res = await fetch(`${BASE}/api${path}`, opts);
  if (!res.ok) {
    let detail;
    try {
      detail = (await res.json())?.detail;
    } catch (e) {
      /* no-op */
    }
    const err = new Error(typeof detail === "string" ? detail : `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export function speakWord(text) {
  try {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "en-GB";
    u.rate = 0.85;
    window.speechSynthesis.speak(u);
  } catch (e) {
    /* no-op */
  }
}
